import { NgModule } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { LanguageModule } from '../language/language.module';
import { SidenavComponent } from './sidenav.component';
import { SidenavRoutingModule } from './sidenav-routing.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationsSidenavModule } from '../notifications-sidenav/notifications-sidenav.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  entryComponents: [],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    HttpClientModule,
    TranslateModule,
    FlexLayoutModule,
    LanguageModule,
    SidenavRoutingModule,
    NotificationsSidenavModule
  ],
  declarations: [
    SidenavComponent
  ],
  exports: [SidenavComponent],
  bootstrap: [SidenavComponent]
})
export class SidenavModule { }
